import { gql } from "@apollo/client";
import { TOPIC_BASIC_FIELDS_FRAGMENT } from "../fragments/TopicFragments";

// TODO: add input data for this query
// to reflect the filter options that user has chosen
const GET_SEARCH_RESULT = gql`
  query ClassSearchResults(
    $levelId: ID!
    $classType: String!
    $days: [String!]!
    $time: [Int!]!
    $includeStudiedTopics: Boolean!
    $excludeAllCityVerion: Boolean!
    $categoryIds: [ID!]!
    $spokenOnly: Boolean!
    $numberOfTopicsAhead: Int!
    $cities: [String!]!
    $first: Int
    $after: String
  ) {
    classSearchResults(
      filter: {
        levelId: $levelId
        classType: $classType
        days: $days
        time: $time
        includeStudiedTopics: $includeStudiedTopics
        excludeAllCityVerion: $excludeAllCityVerion
        categoryIds: $categoryIds
        spokenOnly: $spokenOnly
        numberOfTopicsAhead: $numberOfTopicsAhead
        cities: $cities
      }
      first: $first
      after: $after
    ) {
      pageInfo {
        endCursor
        startCursor
        hasPreviousPage
        hasNextPage
      }
      nodes {
        date
        lessons {
          id
          credits
          date
          time
          startTime
          classType
          classSize
          category
          seatsRemaining
          bookedAt
          overlapped
          language {
            id
            englishName
            realName
            bannerBackground
          }
          teacher {
            id
            avatar
            givenName
            familyName
          }
          topic {
            ...TopicBasicFields
          }
          chapter {
            name
          }
          level {
            title
          }
          city {
            id
            name
          }
        }
      }
    }
  }
  ${TOPIC_BASIC_FIELDS_FRAGMENT}
`;

export default GET_SEARCH_RESULT;
